import { BreakpointsOptions, createTheme } from '@mui/material/styles';
import { componentsOverride, DEFAULT_FONT } from './components';

export type ColorOption = {
  light: string;
  main: string;
  dark: string;
};

export type ColorOptionWithContrast = ColorOption & {
  contrastText: string;
};

export type ColorPalette = {
  primary: ColorOptionWithContrast;
  secondary: ColorOptionWithContrast;
  warning: ColorOption;
  info: ColorOption;
  error: ColorOption;
  success: ColorOption;
  grey: {
    '50': string;
    '100': string;
    '200': string;
    '300': string;
    '400': string;
    '500': string;
    '600': string;
    '700': string;
    '800': string;
    '900': string;
  };
  common: {
    black: string;
    white: string;
  };
};

export type ColorType = 'primary' | 'secondary' | 'info' | 'success' | 'warning' | 'error';

type ThemeOptions = {
  palette: ColorPalette;
  breakpoints?: BreakpointsOptions;
  font?: string;
};

export const getTheme = ({ palette, breakpoints, font }: ThemeOptions) =>
  createTheme({
    palette,
    components: componentsOverride(palette, font),
    typography: {
      fontFamily: `${font || DEFAULT_FONT}, Arial, sans-serif`,
    },
    breakpoints: breakpoints,
  });
